import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './ConectarTikTokPublic.css';
import Loading from '../components/Loading';

const ConectarTikTokPublic = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [influencerData, setInfluencerData] = useState(null);

  console.log('🎯 ConectarTikTokPublic renderizado. Token:', token);

  useEffect(() => {
    const validateToken = async () => {
      try {
        console.log('🔍 Validando token TikTok:', token);

        // Usar la URL completa del backend en lugar de URL relativa
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/content';
        const validationUrl = `${apiUrl}/public/validate-tiktok-token/${token}/`;

        console.log('🌐 URL de validación TikTok:', validationUrl)


        const response = await axios.get(validationUrl);

        console.log('✅ Respuesta de validación TikTok:', response.data);

        if (response.data.success) {
          setInfluencerData(response.data);
        } else {
          setError(response.data.error);
        }
      } catch (err) {
        console.error('❌ Error al validar token TikTok:', err);
        console.error('❌ Response:', err.response);
        const errorMsg = err.response?.data?.error || 'Error al validar el link. Por favor, solicita uno nuevo.';
        setError(errorMsg);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      validateToken();
    } else {
      setError('Token no proporcionado en la URL');
      setLoading(false);
    }
  }, [token]);

  const handleConnectTikTok = () => {
    if (!influencerData) return;

    // Obtener el host base SIN /api/content
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    // Remover /api/content o /api si existe
    const backendUrl = apiUrl.replace(/\/api(\/content)?\/?$/, '');
    const connectUrl = `${backendUrl}/api/tiktok/connect-influencer/${influencerData.influencer_id}/`;

    console.log('🔗 Redirigiendo a TikTok:', connectUrl);

    // Redirigir directamente (no popup en este caso, porque el influencer está en su propio navegador)
    window.location.href = connectUrl;
  };

  if (loading) {
    return (
      <div className="public-connect-container tiktok">
        <div className="public-connect-card">
          <Loading fullScreen={false} mensaje="Verificando link" />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="public-connect-container tiktok">
        <div className="public-connect-card error-card">
          <div className="error-icon">❌</div>
          <h2>Link Inválido o Expirado</h2>
          <p className="error-message">{error}</p>
          <p className="error-help">
            Por favor, contacta al administrador para obtener un nuevo link de conexión.
          </p>
        </div>
      </div>
    );
  }

  // Si no hay datos del influencer todavía, no renderizar nada (loading o error ya se manejan arriba)
  if (!influencerData) {
    return null;
  }

  if (influencerData.tiktok_connected) {
    return (
      <div className="public-connect-container tiktok">
        <div className="public-connect-card success-card">
          <div className="success-icon">✅</div>
          <h2>Cuenta Ya Conectada</h2>
          <div className="influencer-info">
            {influencerData.influencer_profile_image_url && influencerData.influencer_profile_image_url.trim() !== '' && (
              <img
                src={influencerData.influencer_profile_image_url}
                alt={influencerData.influencer_name || 'Influencer'}
                className="influencer-avatar-large"
              />
            )}
            <h3>{influencerData.influencer_name || 'Influencer'}</h3>
            <p className="tiktok-username">@{influencerData.influencer_username || 'username'}</p>
          </div>
          <p className="success-message">
            Tu cuenta de TikTok <strong>@{influencerData.tiktok_username || 'tu cuenta'}</strong> ya está conectada.
          </p>
          <p className="success-help">
            Puedes cerrar esta ventana. El administrador puede publicar contenido en tu cuenta de forma automática.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="public-connect-container tiktok">
      <div className="public-connect-card">
        {/* Header */}
        <div className="public-header">
          <div className="header-icon-large">🎵</div>
          <h1>Conecta tu cuenta de TikTok</h1>
        </div>

        {/* Influencer Info */}
        <div className="influencer-info">
          {influencerData.influencer_profile_image_url && influencerData.influencer_profile_image_url.trim() !== '' && (
            <img
              src={influencerData.influencer_profile_image_url}
              alt={influencerData.influencer_name || 'Influencer'}
              className="influencer-avatar-large"
            />
          )}
          <h2>Hola, {influencerData.influencer_name || 'Influencer'}</h2>
          <p className="tiktok-username">@{influencerData.influencer_username || 'username'}</p>
        </div>

        {/* Info Section */}
        <div className="info-section">
          <p className="info-text">
            Para poder publicar contenido en tu cuenta de TikTok de forma automática,
            necesitamos que autorices tu cuenta.
          </p>

          <div className="features-list">
            <div className="feature-item">
              <span className="feature-icon">🔒</span>
              <span className="feature-text">Seguro y privado</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span className="feature-text">Solo tú puedes autorizar</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🔄</span>
              <span className="feature-text">Puedes revocar en cualquier momento</span>
            </div>
          </div>
        </div>

        {/* Connect Button */}
        <button
          onClick={handleConnectTikTok}
          className="btn-connect-tiktok"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
          </svg>
          Conectar mi TikTok
        </button>

        {/* Requirements */}
        <div className="requirements-section">
          <h4>Requisitos:</h4>
          <ul className="requirements-list">
            <li>Cuenta de TikTok con acceso a <strong>Business Suite</strong></li>
            <li>Ser el propietario de la cuenta</li>
            <li>Tener permisos para autorizar aplicaciones</li>
          </ul>
        </div>

        {/* Footer */}
        <div className="public-footer">
          <p className="footer-text">
            Al conectar tu cuenta, autorizas a la plataforma para publicar contenido
            previamente aprobado en tu cuenta de TikTok.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConectarTikTokPublic;
